import styled from '@emotion/styled';
import { RadioButton } from '@kompare/kompare-ui-library';
import { useEffect, useState } from 'react';
import { ValidationErrorStyle } from 'src/common';
import { InputLabel } from 'src/components';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const RadioButtonContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const InputLabelStyle = styled(InputLabel)({
  marginBottom: '4px',
});

export type RadioButtonInputProps = {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  error?: string;
  className?: string;
  options: Array<{ value: string; label: string }>;
};

export const RadioButtonInput: React.FC<RadioButtonInputProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  error = '',
  className,
  options,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | undefined>(value);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const handleOptionChange = (optionValue: string) => {
    if (disabled) return;
    setSelectedOption(optionValue);
    if (onChange) onChange(optionValue);
  };

  return (
    <Container className={className}>
      {label && <InputLabelStyle disabled={disabled}>{label}</InputLabelStyle>}
      <div style={{ display: 'flex', gap: '16px' }}>
        {options.map((option) => (
          <RadioButtonContainer key={option.value}>
            <RadioButton
              value={option.value}
              label={option.label}
              checked={selectedOption === option.value}
              onChange={() => handleOptionChange(option.value)}
              disabled={disabled}
            />
          </RadioButtonContainer>
        ))}
      </div>
      {error && <ValidationErrorStyle>{error}</ValidationErrorStyle>}
    </Container>
  );
};
